<div class="row">
    <div class="col-md-12">
        <p [innerHTML]="validationText"></p>
    </div>
</div>
<br>
<div class="row">
    <div class="col-md-12">
        <table class="table table-bordered table-striped table-textCenter" aria-describedby="row">
            <thead>
                <tr>
                    <th class="thead text-center">Query Reference Number</th>
                    <th class="thead text-center">Request Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let query of openQueries">
                    <td class="text-center"><a routerLink="/clarification-query/view-query/{{query.QueryCode}}"
                            (click)="closeModal()" >
                            <strong>{{query.QueryRequestNumber}}</strong></a>
                    </td>
                    <td class="text-center">{{query.QueryStatus}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>